import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export function Shell({
	children,
	align = "center",
}: {
	children: ReactNode;
	align?: "center" | "top";
}) {
	return (
		<div className="fixed inset-0 overflow-y-auto overscroll-contain bg-background">
			<div
				className={cn(
					"flex min-h-full flex-col items-center px-6 py-12 sm:py-20",
					align === "top" ? "justify-start sm:justify-center" : "justify-center",
				)}
			>
				{children}
			</div>
		</div>
	);
}
